var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    staticClass: "all_join",
    attrs: {
      "width": "600",
      "mask-closable": false,
      "title": $t("it0tx84", "邀请加入")
    },
    on: {
      "on-cancel": _vm.clean
    },
    model: {
      value: _vm.modal.visible,
      callback: function ($$v) {
        _vm.$set(_vm.modal, "visible", $$v);
      },
      expression: "modal.visible"
    }
  }, [_c('div', [_vm._v(` ${$t("gnyy2", "当前")} ` + _vm._s(_vm.allJoinNumber) + ` ${$t("vfs6w0a", "位成员未加入，已选择")} ` + _vm._s(_vm.selectUserNumber) + ` ${$t("6mnzj1g", "位，将通过短信或邮箱发送邀请通知")} `)]), _vm.modal.visible ? _c('pro-table', _vm._b({
    on: {
      "on-selection-change": _vm.onSelectUser
    }
  }, 'pro-table', _vm.config, false)) : _vm._e(), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    on: {
      "click": _vm.clean
    }
  }, [_vm._v($t("ev022", "取消"))]), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.modal.loading
    },
    on: {
      "click": _vm.onCommit
    }
  }, [_vm._v($t("fiz8cy6", "发送邀请通知"))])], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };